import { render } from "./ClinicSearchSpinner.vue?vue&type=template&id=30f30e58&ts=true"
import script from "./ClinicSearchSpinner.vue?vue&type=script&lang=ts"
export * from "./ClinicSearchSpinner.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__